export class PerformancePeerGroupModel {
  name: string;
  criteria: any[];
  practiceGroup: any[];
  offices: any[];
}
